import { render } from "./tool_image_gallery.vue?vue&type=template&id=1a0a8d56&scoped=true"
import script from "./tool_image_gallery.vue?vue&type=script&lang=js"
export * from "./tool_image_gallery.vue?vue&type=script&lang=js"

import "./tool_image_gallery.vue?vue&type=style&index=0&id=1a0a8d56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0a8d56"]])

export default __exports__